import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=4d4856e1&scoped=true"
import script from "./Atlas.vue?vue&type=script&lang=js"
export * from "./Atlas.vue?vue&type=script&lang=js"
import style0 from "./Atlas.vue?vue&type=style&index=0&id=4d4856e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4856e1",
  null
  
)

export default component.exports